import { PipeTransform, Pipe } from "@angular/core";
import { Work } from '../interfaces/work.interface';

@Pipe({
    name: 'relatedFilter'
})
export class relatedPipe implements PipeTransform {
    transform(work, tags, title: string) {
        if (work && work.length) {
            return work.filter(work => {
                return this.workHandler(tags, work, title);
            });
        }
    }

    workHandler(tags, work, title) {
        if (title !== work.title.rendered) {
            if (new RegExp(tags.join("|")).test(work.acf.tags)) {
                return true;
            } else {
                return false;
            }
        }
        else {
            return false;
        }
    }
}

